import { useTranslation } from "react-i18next";
import { Upload } from "lucide-react";
import { cn } from "@tellescope/utils";
import { Card } from "@tellescope/ui";

interface FileFieldDropzoneProps {
  multiple: boolean;
  isDragging: boolean;
  hasValidationError: boolean;
  validFileTypes?: string;
  maxSizeMB?: number;
  onClick: () => void;
  onDragEnter: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const FileFieldDropzone = ({
  multiple,
  isDragging,
  hasValidationError,
  validFileTypes,
  maxSizeMB,
  onClick,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
}: FileFieldDropzoneProps) => {
  const { t } = useTranslation("forms");

  return (
    <Card
      className={cn(
        "border-2 border-dashed cursor-pointer transition-colors",
        isDragging
          ? "border-primary bg-muted"
          : "border-muted-foreground/25 hover:border-muted-foreground/50 hover:bg-muted/50",
        hasValidationError ? "border-destructive" : ""
      )}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onClick={onClick}
    >
      <div className="flex flex-col items-center justify-center p-6 text-center">
        <Upload className="h-10 w-10 text-muted-foreground mb-2" />
        <p className="text-sm text-muted-foreground">
          {multiple ? t("Drop files here or click to select") : t("Drop a file here or click to select")}
        </p>
        {validFileTypes && (
          <p className="text-xs text-muted-foreground mt-1">
            {t("Allowed types")}: {validFileTypes}
          </p>
        )}
        {maxSizeMB && (
          <p className="text-xs text-muted-foreground">
            {t("Max size")}: {maxSizeMB >= 1024 ? `${maxSizeMB / 1024} GB` : `${maxSizeMB} MB`}
          </p>
        )}
      </div>
    </Card>
  );
};
